import LeadForm from '../components/eclora/LeadForm';
import { FadeIn } from '../components/eclora/Reveal';

export default function FinalCta() {
    return (
        <section className="relative overflow-hidden px-6 py-20 sm:px-10 lg:py-32" data-testid="final-cta-section">
            <div aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-champagne/40" />
            <div
                aria-hidden="true"
                className="pointer-events-none absolute left-1/2 top-1/2 h-[42rem] w-[42rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-nude/25 blur-3xl"
            />
            <div className="relative mx-auto max-w-xl text-center">
                <FadeIn>
                    <p className="eyebrow">Chapitre 06 — L'éclosion</p>
                    <h2 className="mt-6 font-serif text-3xl font-medium leading-tight text-bordeaux sm:text-4xl lg:text-5xl">
                        Et si ton prochain chapitre commençait aujourd'hui ?
                    </h2>
                </FadeIn>
                <FadeIn delay={0.15}>
                    <p className="mt-6 text-base leading-relaxed text-cacao/90 sm:text-lg">
                        Tu n'as pas besoin d'avoir toutes les réponses.
                        <br />
                        Tu as simplement besoin de faire le premier pas.
                    </p>
                </FadeIn>

                <FadeIn delay={0.25} className="mt-10">
                    <LeadForm
                        source="final"
                        idPrefix="final"
                        buttonLabel="🌿 JE COMMENCE MON ÉCLORA"
                        footnote="Reset Éclora est offert."
                    />
                </FadeIn>

                <FadeIn delay={0.35} className="mt-14 space-y-4">
                    <p className="font-script text-3xl text-champagne sm:text-4xl">Imagine-la. Aligne-toi. Agis. Éclos.</p>
                    <p className="text-serifit text-xl text-bordeaux sm:text-2xl" data-testid="final-signature">
                        Il n'est jamais trop tard pour éclore.
                    </p>
                </FadeIn>
            </div>
        </section>
    );
}
